module.exports = __webpack_public_path__ + "static/media/complect.9713aaf8.png";